export const base64Encode = (data: string) => {
  return btoa(data).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const base64Decode = (data: string) => {
  return atob(data);
};
